const bottomSectionClasses = 'p-4 rounded-bottom-3 border-start border-end border-bottom'

export { bottomSectionClasses }
